export const enum HomepageHeroSlideName {
  gardeners = 'gardeners_slide',
  territoryDiscovery = 'territory_discovery_slide',
  eoy = 'eoy_slide',
}
export const EOY_LINK = `https://app.t2.world/article/cm4ws7taw357602tnmcd3ojy65n`;
export const GARDENERS_LINK = `https://www.thegardeners.xyz/`;
export const TERRITORY_DISCOVERY_LINK = `https://app.t2.world/discover/territories`;
